import z from 'zod';

export const getProductTiersResponseSchema = z
  .object({
    id: z.string(),
    creditLimit: z.number(),
    annualInterestRate: z.number(),
  })
  .array();

export const getEmbeddedPartnersResponseSchema = z
  .object({
    id: z.string(),
    name: z.string(),
  })
  .array();
